 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"bangladesh-bangladesh-module":"bangladesh-bangladesh-module","bus-ticket-bus-ticket-module":"bus-ticket-bus-ticket-module","busbooking-busbooking-module":"busbooking-busbooking-module","commission-commission-module":"commission-commission-module","common":"common","balance-balance-module":"balance-balance-module","credit-credit-module":"credit-credit-module","monthly-monthly-module":"monthly-monthly-module","nw-rate-nw-rate-module":"nw-rate-nw-rate-module","posm-test-posm-test-module":"posm-test-posm-test-module","sales-product-sales-product-module":"sales-product-sales-product-module","sales-provider-sales-provider-module":"sales-provider-sales-provider-module","weekly-weekly-module":"weekly-weekly-module","contactus-contactus-module":"contactus-contactus-module","core-js-js":"core-js-js","courier-main-courier-main-module":"courier-main-courier-main-module","css-shim-206ea950-3169f23e-js":"css-shim-206ea950-3169f23e-js","danai-danai-module":"danai-danai-module","dashboard-dashboard-module":"dashboard-dashboard-module","default~daily-daily-module~danai-success-danai-success-module~eticket-success-eticket-success-module~2c4123aa":"default~daily-daily-module~danai-success-danai-success-module~eticket-success-eticket-success-module~2c4123aa","daily-daily-module":"daily-daily-module","danai-success-danai-success-module":"danai-success-danai-success-module","eticket-success-eticket-success-module":"eticket-success-eticket-success-module","failed-failed-module":"failed-failed-module","nw-success-nw-success-module":"nw-success-nw-success-module","nw-success-return-do-nw-success-return-do-module":"nw-success-return-do-nw-success-return-do-module","posm-ordering-posm-ordering-module":"posm-ordering-posm-ordering-module","success-success-module":"success-success-module","dextoken-dextoken-module":"dextoken-dextoken-module","dom-96781eef-a2fb04dd-js":"dom-96781eef-a2fb04dd-js","dom-js":"dom-js","eticketing-main-eticketing-main-module":"eticketing-main-eticketing-main-module","faq-faq-module":"faq-faq-module","feedback-feedback-module":"feedback-feedback-module","index-69c37885-js":"index-69c37885-js","info-info-module":"info-info-module","inreload-inreload-module":"inreload-inreload-module","inreload-main-inreload-main-module":"inreload-main-inreload-main-module","lazada-lazada-module":"lazada-lazada-module","members-member-routing-module":"members-member-routing-module","nepal-nepal-module":"nepal-nepal-module","nw-main-nw-main-module":"nw-main-nw-main-module","nw-nw-module":"nw-nw-module","nw-parcel-nw-parcel-module":"nw-parcel-nw-parcel-module","nw-parcel-return-do-nw-parcel-return-do-module":"nw-parcel-return-do-nw-parcel-return-do-module","nw-pl9-create-nw-pl9-create-module":"nw-pl9-create-nw-pl9-create-module","nw-pl9-nw-pl9-module":"nw-pl9-nw-pl9-module","nw-pl9-search-nw-pl9-search-module":"nw-pl9-search-nw-pl9-search-module","nw-return-do-create-nw-return-do-create-module":"nw-return-do-create-nw-return-do-create-module","nw-search-nw-search-module":"nw-search-nw-search-module","password-password-module":"password-password-module","payment-payment-module":"payment-payment-module","posm-customer-add-posm-customer-add-module":"posm-customer-add-posm-customer-add-module","posm-customer-posm-customer-module":"posm-customer-posm-customer-module","posm-customer-search-posm-customer-search-module":"posm-customer-search-posm-customer-search-module","posm-main-posm-main-module":"posm-main-posm-main-module","posm-merchandise-ddet-posm-merchandise-ddet-module":"posm-merchandise-ddet-posm-merchandise-ddet-module","posm-merchandise-drop-posm-merchandise-drop-module":"posm-merchandise-drop-posm-merchandise-drop-module","posm-merchandise-pdet-posm-merchandise-pdet-module":"posm-merchandise-pdet-posm-merchandise-pdet-module","posm-merchandise-purchase-posm-merchandise-purchase-module":"posm-merchandise-purchase-posm-merchandise-purchase-module","posm-merchandising-posm-merchandising-module":"posm-merchandising-posm-merchandising-module","posm-parcel-posm-parcel-module":"posm-parcel-posm-parcel-module","posm-pl9-create-posm-pl9-create-module":"posm-pl9-create-posm-pl9-create-module","posm-pl9-posm-pl9-module":"posm-pl9-posm-pl9-module","posm-pl9-search-posm-pl9-search-module":"posm-pl9-search-posm-pl9-search-module","posm-posm-module":"posm-posm-module","posm-search-posm-search-module":"posm-search-posm-search-module","posm-send-posm-send-module":"posm-send-posm-send-module","posm-track-posm-track-module":"posm-track-posm-track-module","product-product-module":"product-product-module","profile-profile-module":"profile-profile-module","public-login-login-module":"public-login-login-module","public-register-register-module":"public-register-register-module","receipt-receipt-module":"receipt-receipt-module","reload-reload-module":"reload-reload-module","sales-profit-sales-profit-module":"sales-profit-sales-profit-module","services-services-module":"services-services-module","services-success-services-success-module":"services-success-services-success-module","shadow-css-4889ae62-23996f3f-js":"shadow-css-4889ae62-23996f3f-js","shopee-shopee-module":"shopee-shopee-module","terms-terms-module":"terms-terms-module","tml-daily-tml-daily-module":"tml-daily-tml-daily-module","tml-wallet-tml-wallet-module":"tml-wallet-tml-wallet-module","touchngo-touchngo-module":"touchngo-touchngo-module","transaction-transaction-module":"transaction-transaction-module","wallet-wallet-module":"wallet-wallet-module","swiper-bundle-ccdaac54-js":"swiper-bundle-ccdaac54-js","ios-transition-071bd421-js":"ios-transition-071bd421-js","md-transition-15a81b08-js":"md-transition-15a81b08-js","swipe-back-35ad8e37-js":"swipe-back-35ad8e37-js","focus-visible-70713a0c-js":"focus-visible-70713a0c-js","hardware-back-button-5afe3cb0-js":"hardware-back-button-5afe3cb0-js","input-shims-a4fc53ac-js":"input-shims-a4fc53ac-js","status-tap-a0df8284-js":"status-tap-a0df8284-js","tap-click-ca00ce7f-js":"tap-click-ca00ce7f-js"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
